import { AxiosInstance } from 'axios'
import { InjectionKey } from '@vue/composition-api'

export interface Moment {
  id: unknown
}

export class MomentsApi {
  constructor(private client: AxiosInstance, private uri: string) {}

  private path(path: string): string {
    return this.uri + path
  }

  getMoments(conversationId: number, side: string) {
    return this.client
      .get(this.path(`/${conversationId}/side/${side}`))
      .then(response => {
        return response?.data || []
      })
  }

  createMoment(conversationId: number, moment: unknown) {
    return this.client
      .post(this.path(`/${conversationId}`), moment)
      .then(response => {
        return response?.data || []
      })
  }

  saveMoment(conversationId: number, moment: Moment) {
    return this.client
      .put(this.path(`/${conversationId}/${moment.id}`), moment)
      .then(response => {
        return response?.data || []
      })
  }

  deleteMoment(conversationId: number, momentId: number) {
    return this.client
      .delete(this.path(`/${conversationId}/${momentId}`))
      .then(response => {
        return response?.data || []
      })
  }
}

export const MomentsApiKey: InjectionKey<MomentsApi> = Symbol()
